import type { FolderResponse, RoomResponse } from '../api/types'

export type AskTargetType = 'Room' | 'Folder' | 'Document'

/**
 * Where the caller may ask, from the bits the server sent per node. The ask bit is granted
 * per node like every other bit (qa.usp_Question_Create checks it on the target), so a
 * reviewer with ask_question on one folder and nothing on the room must still get the
 * button, and must not be offered "the room in general" as a target, which the proc would
 * refuse. Documents are only known per folder, so a grant on a single document whose
 * folder carries no grant stays invisible here; the proc, not this list, is the authority.
 */
export function askTargets(room: RoomResponse, folders: readonly FolderResponse[] | undefined) {
  const askableFolders = (folders ?? []).filter((f) => f.permissions.askQuestion)
  const roomWide = room.permissions.askQuestion
  const types: AskTargetType[] = roomWide
    ? ['Room', 'Folder', 'Document']
    : askableFolders.length > 0
      ? ['Folder', 'Document']
      : []
  return {
    canAsk: room.status === 'Open' && types.length > 0,
    types,
    // With the room bit, every folder is a target; without it, only the granted ones.
    folders: roomWide ? (folders ?? []) : askableFolders,
    roomWide,
  }
}
